export default class extends Controller {
  connect() {
    var containerSel = "#schedulables--calendar";
    App.Calendar.init(containerSel);
    App.Calendar.getCalendarContent(containerSel, $('[data-field=calendar-url]').val());
  }
};



// WEBPACK FOOTER //
// ./app/components/schedulables/assets/javascript/schedulables-index-controller.js